<template>
  <div>
    <Dialog
        :dismissableMask="true"
        :style="{ width: '35vw' }"
        :modal="true"
        :visible.sync="show"
        @hide="closeDialog"
        :contentStyle="{overflow: 'visible'}"
    >
      <template #header>
        <i style=" transform: scale(1.7); " class="pi pi-th-large"></i>
        <h1>הוספת זמן מערכת</h1>
      </template>


      <div class="p-p-4 p-fluid p-grid ">

        <div class="p-field p-col-12 p-md-12">
          <label>שם</label>
            <InputText  type="text" v-model="hebrewName" />
        </div>
          <div class="p-field p-col-12 p-md-12">
          <label>שם מקוצר</label>
            <InputText  type="text" v-model="shortName" />
        </div>
        <div class=" p-fluid p-grid">

        <div class="p-field p-col-12 p-md-6">
              <label for="startDate">תאריך התחלה</label>
              <calendar :showTime="true" type="text" v-model="startDate" />
          </div>
          <div class="p-field p-col-12 p-md-6">
              <label for="endDate">תאריך סוף</label>
              <calendar :showTime="true" type="text" v-model="endDate" />
          </div>
        </div>
        </div>


      <template #footer>
        <Button
            label="ביטול"
            icon="pi pi-times"
            @click="closeDialog"
            class="p-button-secondary"
        />
        <Button class="p-button-success" label="הוספה" icon="pi pi-check" @click="post"/>
      </template>
    </Dialog>
  </div>
</template>

<script>
import Service from "../../../../service/Service";

export default {
  service: null,
  props: {
    show: Boolean,
  },
  created() {
    this.service = new Service();
  },
  mounted() {
    this.resetFields();
  },
  data() {
    return {
        ENTITY: 'system-date',
        hebrewName: null,
        shortName: null,
        startDate:  new Date(),
        endDate :  new Date()
    };
  },

  methods: {
    resetFields() {
      this.hebrewName = null
      this.shortName = null
      this.startDate = new Date()
      this.endDate = new Date()
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    async post() {

      if ( true) {
          const objToPost = {
              hebrewName: this.hebrewName,
              shortName: this.shortName,
              startDate: this.startDate.getTime(),
              endDate: this.endDate.getTime()
          }
        await this.service
          .post(objToPost, this.ENTITY)
          .then((data) => {
            this.$emit("addItem", objToPost);
            this.resetFields();
            this.openNotification(
              "success",
              `מעולה`,
              `המידע התוסף במערכת`
            );

            this.closeDialog();
          })
          .catch(() => {
            this.openNotification(
              "danger",
              `אופס`,
              `אולי קיים כבר משתמש עם ת.ז. זהה`
            );
          });
      } else {
        this.openNotification(
          "danger",
          `אופס`,
          `חלק מהשדות חסרים או שגויים`
        );
      }
    },
    openNotification(color, title, text, position = "right-left", duration = 3000) {
      this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
    },
  },
};
</script>

<style >
</style>